import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { ReactComponent as TaskSparkIcon } from '../assets/header-icons/ai-task-spark.svg';
import { ReactComponent as ImageSparkIcon } from '../assets/header-icons/ai-image-spark.svg';
import { ReactComponent as InfinityIcon } from '../assets/header-icons/unlimited-infinity.svg';

const CreditPill = ({ icon, label, usage }) => {
  if (!usage) return null;
  const value = usage.unlimited
    ? 'Unlimited'
    : `${usage.remaining_count}/${usage.allowed_count}`;

  return (
    <Tooltip title={usage.unlimited ? `Unlimited ${label.toLowerCase()}` : `${label}: ${usage.remaining_count} of ${usage.allowed_count} remaining`}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 0.25, sm: 0.5 },
          border: '1px solid',
          borderColor: usage.available ? 'primary.main' : 'secondary.main',
          borderRadius: '16px',
          px: { xs: 0.5, sm: 0.75 },
          py: 0.125,
          background: 'linear-gradient(135deg, rgba(0,229,255,0.09), rgba(18,24,22,0.92))',
        }}
        aria-label={`${label}: ${value}`}
      >
        {icon}
        <Typography component="span" variant="caption" aria-hidden="true" sx={{ color: 'text.primary', fontSize: { xs: 7, sm: 9 } }}>
          :
        </Typography>
        {usage.unlimited ? (
          <Box
            component={InfinityIcon}
            aria-hidden="true"
            focusable="false"
            sx={{ width: { xs: 16, sm: 20, md: 24 }, height: { xs: 16, sm: 20, md: 24 }, flexShrink: 0, color: 'text.primary' }}
          />
        ) : (
          <Typography variant="caption" sx={{ color: 'text.primary', whiteSpace: 'nowrap', fontSize: { xs: 7, sm: 9 } }}>
            {value}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

const AIUsageCredits = ({ usage, source }) => {
  if (!usage) return null;
  const passName = { trial: 'Trial', lifetime: 'Lifetime', paid: 'Unlimited', free: 'Free' }[source]
    || (usage.task_generation?.unlimited && usage.reward_image?.unlimited ? 'Unlimited' : 'Free');

  return (
    <Box aria-label={`${passName} pass`} sx={{ display: 'flex', flexDirection: 'column', gap: 0.375, flexShrink: 0 }}>
      <Typography component="div" sx={{ fontSize: { xs: 7, sm: 9 }, lineHeight: 1.5, color: 'primary.main', textAlign: 'center' }}>
        {passName}
      </Typography>
      <CreditPill
        label="AI tasks"
        usage={usage?.task_generation}
        icon={<Box component={TaskSparkIcon} aria-hidden="true" focusable="false" sx={{ width: { xs: 16, sm: 20, md: 24 }, height: { xs: 16, sm: 20, md: 24 }, flexShrink: 0, color: 'primary.main' }} />}
      />
      <CreditPill
        label="AI images"
        usage={usage?.reward_image}
        icon={<Box component={ImageSparkIcon} aria-hidden="true" focusable="false" sx={{ width: { xs: 16, sm: 20, md: 24 }, height: { xs: 16, sm: 20, md: 24 }, flexShrink: 0, color: 'secondary.main' }} />}
      />
    </Box>
  );
};

export default AIUsageCredits;
